import { Field, Flex, SimpleGrid, Textarea } from "@chakra-ui/react";
import TableList from "components/TableList";
import useCheckMobileScreen from "hooks/useCheckMobileScreen";
import { useLocation, useNavigate } from "react-router-dom";
import { ToggleSwitch } from "components/ToggleSwitch";
import { useEffect, useState } from "react";
import { Header } from "components/Header";
import InputComp from "components/InputComp";
import { api } from "services/api";
import { toaster } from "components/ui/toaster";
import constant from "constant";
import utils from "utils";
import { CardRegistration } from "components/CardRegistration";
import ButtonComp from "components/Button";
import Layout from "components/Layout";

const fs = "sm";

const headers = [
  "Agreements",
  "State",
  "Created",
  "Retailer",
  "Details",
  "Products",
  // "Remaining",
  "Cover",
  "Limit",
  // "Duration",
  // "StartDate",
  "Validity",
];

// const items = [
//   {
//     Agreements: "MA13FPZ",
//     State: "Paid",
//     Created: "19-4-2024",
//     Retailer: "Spirit Motor Company",
//     Details: "BMW 1 SERIES Diesel WHITE",
//     Products: "15 Months",
//     Remaining: "8 Months",
//     Cover: "Standard",
//     Limit: "1000",
//     Validity: "Valid",
//   },
// ];

const getAdrForPrint = ({ add1, add2, add3, town, county }) => {
  let add1new = add1 || "";
  let add2new = add2 || "";
  let add3new = add3 || "";

  let town_new = town || "";
  let county_new = county || "";

  if (add1new === add2new) {
    add2new = "";
  }

  if (add1new === add3new) {
    add3new = "";
  }

  if (add2new === add3new) {
    add3new = "";
  }

  if (town_new === county_new) {
    county_new = "";
  }

  // new
  if (add2new && add3new) {
    add2new += ", ";
  }
  add2new += add3new;

  add3new = town_new;
  if (add3new && county_new) {
    add3new += ", ";
  }
  add3new += county_new;

  return {
    add1: add1new,
    add2: add2new,
    add3: add3new,
    // town: town_new,
    // county: county_new,
  };
};

const getTxtPolicyDetails = (data) => {
  console.log("getTxtPolicyDetails", data);

  if (!data) {
    return "";
  }
  const res = getAdrForPrint({
    add1: data?.address1,
    add2: data?.address2,
    add3: data?.address3,
    town: data?.town,
    county: data?.county,
  });

  console.log("getAdrForPrint", res);

  let result = "";
  if (res?.add1) {
    result += res?.add1;
  }

  if (result && res.add2) {
    result += ", ";
  }
  if (res?.add2) {
    result += res?.add2;
  }

  if (result && res.add3) {
    result += ", ";
  }
  if (res?.add3) {
    result += res?.add3;
  }

  if (result) {
    return result;
  }
  return "";
};

const PolicyInfo = ({ data }) => {
  const itm = data?.item?.data;
  const adds = getTxtPolicyDetails(itm);
  let res = "";
  // data?.item?.data

  if (res && itm?.title) {
    res += " ";
  }
  if (itm?.title) {
    res += itm?.title;
  }

  if (res && itm?.forename) {
    res += " ";
  }
  if (itm?.forename) {
    res += itm?.forename;
  }

  if (res && itm?.surname) {
    res += " ";
  }
  if (itm?.surname) {
    res += itm?.surname;
  }

  if (res && adds) {
    res += " ";
  }
  if (adds) {
    res += adds;
  }

  if (res && itm?.postcode) {
    res += " ";
  }
  if (itm?.postcode) {
    res += itm?.postcode;
  }

  if (res && itm?.mobile) {
    res += " ";
  }
  if (itm?.mobile) {
    res += itm?.mobile;
  }

  // if (res && itm?.carmake) {
  //   res += " ";
  // }
  // if (itm?.carmake) {
  //   res += itm?.carmake;
  // }

  // if (res && itm?.carmodel) {
  //   res += " ";
  // }
  // if (itm?.carmodel) {
  //   res += itm?.carmodel;
  // }

  // if (res && itm?.carcolour) {
  //   res += " ";
  // }
  // if (itm?.carcolour) {
  //   res += itm?.carcolour;
  // }

  return (
    <Field.Label flex={1} textStyle={fs}>
      {res}
    </Field.Label>
  );
};

function ClaimView() {
  const [isLoading, setIsLoading] = useState(false);
  const [list, setList] = useState([]);
  const [selectedItem, setSelectedItem] = useState();

  const [claimRes, setClaimRes] = useState();

  // const [status, setStatus] = useState("");
  // const [payl, setPayl] = useState();

  // const onSave = () => {
  // setStatus("");
  // };

  const [vrm, setVrm] = useState();
  // const [claimStatusDD, setClaimStatusDD] = useState([]);

  const [claimnumber, setClaimnumber] = useState();
  const [notes, setNotes] = useState();
  const [failurecause, setFailurecause] = useState();
  const [lastservicedates, setLastservicedates] = useState();
  const [faultdiagnosed, setFaultdiagnosed] = useState();
  const [confirmedwarrantyclaim, setConfirmedwarrantyclaim] = useState();
  const [advicedtodiagnosefault, setAdvicedtodiagnosefault] = useState();
  const [advicedtosenddiagnostic, setAdvicedtosenddiagnostic] = useState();
  const [hasbooklet, setHasbooklet] = useState();
  const [repairinggarage, setRepairinggarage] = useState();
  const [mileageatclaim, setMileageatclaim] = useState();
  const [policyid, setPolicyid] = useState();
  const [repairsrequired, setRepairsrequired] = useState();
  const [claimnotifyemail, setClaimnotifyemail] = useState();
  const [state, setState] = useState();
  // const [policynumber, setPolicynumber] = useState();
  const [datereg, setDatereg] = useState();
  // const [carmodel, setCarmodel] = useState();

  const navigate = useNavigate();
  const ismobile = useCheckMobileScreen();
  const location = useLocation();
  const itemData = location.state?.data?.itemData;
  const navState = location.state;

  // const onSave = () => {
  //   navigate("/");
  // };

  // const onClose = () => {
  //   navigate("/");
  // };

  const onClear = () => {
    if (navState.action === "claim-add") {
      setDatereg("");
      setVrm("");
      onSearch();
      setClaimnumber();
    }
    setMileageatclaim(0);
    setLastservicedates("");

    // utils.getCliamStatusDD({
    //   setClaimStatusDD,
    // });

    setFaultdiagnosed();
    setConfirmedwarrantyclaim();
    setAdvicedtodiagnosefault();
    setAdvicedtosenddiagnostic();
    setHasbooklet();
    setNotes("");
    setClaimnotifyemail("");
    setRepairinggarage("");
    setFailurecause("");
    setRepairsrequired("");
  };

  const onSendEmail = async () => {
    window.location.href = `mailto:${claimnotifyemail || ""}`;
    // e.preventDefault();
    return;
    // setIsLoading(true);
    // const res = await api.sentClaimnotifyCustomer({
    //   claimid: itemData?.claimid,
    //   // stateid: 30,
    //   // mobile: ,
    //   email: claimnotifyemail,
    //   description: "",
    //   type: "email",
    // });
    // setIsLoading(false);

    // toaster.create({
    //   title: res?.data?.message || res?.message,
    //   type: res?.status === 200 ? "success" : "error",
    // });

    // if (res?.status === 200) {

    // }
  };

  const onSearch = async (v) => {
    console.log("onSearch", v);

    setVrm(v);
    setIsLoading(true);
    const res = await api.getClaimSearchvrm({ searchTxt: v });
    setIsLoading(false);
    if (res?.status === 200) {
      if (res?.data && res?.data[0]) {
        const statesColor = { ...constant.claimStateColor };
        let activePolicyData = {};

        setList(
          res.data.map((item, inx) => {
            const data2 = {
              id: item?.policynumber,
              Agreements: item?.policynumber,
              State: statesColor[item?.state]?.clr
                ? {
                    clr:
                      statesColor && statesColor[item?.state]?.clr
                        ? statesColor[item?.state].clr
                        : undefined,
                    label: item?.statename || "",
                  }
                : item?.statename || "",
              Created: item?.datepolicy
                ? utils.formatToDDMMYYYY(item?.datepolicy)
                : "",
              Retailer: item?.branchname || "",
              Details: `${item?.carmake || ""} ${item?.carmodel || ""} ${
                item?.carcolour || ""
              }`,
              Products: item?.durationvalue
                ? `${item?.durationvalue} ${item?.durationtype || ""}`
                : "",
              // Remaining: item?.remainingmonths
              //   ? `${item?.remainingmonths} M`
              //   : "",
              Cover: item?.covertype || "",
              Limit: item?.claimlimitamount || "",
              // Duration: item?.durationvalue || "",
              // StartDate: utils.dateToDateInput(item?.startdate),
              Validity: item?.expire ? utils.formatToDDMMYYYY(item.expire) : "",
              data: item,
            };

            if (itemData?.policyid === item?.policyid) {
              activePolicyData = {
                item: data2,
                index: inx,
                key: item?.policynumber,
              };
            }

            return data2;
          })
        );

        onSelectItm(activePolicyData, "onload");
      } else {
        setList([]);
      }
    } else {
      setList([]);
      toaster.create({
        title: res?.message,
        type: "error",
      });
    }
  };

  const onNext = () => {
    let errMsg = "";

    if (!errMsg && !vrm) {
      errMsg = "please search and select policy";
    }

    if (!errMsg && !policyid) {
      errMsg = "please select policy";
    }

    // if (!errMsg && !state) {
    //   errMsg = "please select state";
    // }

    if (!errMsg && !claimnotifyemail) {
      errMsg = "please enter email";
    }

    if (errMsg) {
      toaster.create({
        title: errMsg,
        type: "error",
      });
      return;
    }

    const v = {
      // ...itemData,
      ...claimRes,
      vrm: vrm,
      mileageatclaim: mileageatclaim || 0,
      // failedpart: "",
      // failedarea: "",
      failurecause: failurecause || "",
      repairsrequired: repairsrequired || "", // 5
      // labourperhour: 0,
      // partstotal: 0,
      // labourtotal: 0,
      // calculatedtotal: 0,
      // claimvatamt: 0, //10
      // claimtotal: 0,
      // payvat: false,
      // adjustedclaim: 0,
      policyid: policyid,
      lastservicedates: lastservicedates || "", //15
      faultdiagnosed: faultdiagnosed ? true : false,
      confirmedwarrantyclaim: confirmedwarrantyclaim ? true : false,
      advicedtodiagnosefault: advicedtodiagnosefault ? true : false,
      advicedtosenddiagnostic: advicedtosenddiagnostic ? true : false,
      hasbooklet: hasbooklet === true ? false : true, // 20
      repairinggarage: repairinggarage || "",
      dateclaim: utils.dateToDateInput(),
      claimdateseconds: utils.yyyymmddToDbSec(new Date()),
      state: state, // 25
      notes: notes || "",
      // claimsvatcent: "",
      claimnotifyemail: claimnotifyemail || "",
      company: selectedItem?.item?.data?.company,
      // backnav
      datereg,
      claimnumber,
    };

    let action2 = "claimviewstepparts-add";
    if (navState?.action === "claim-edit") {
      action2 = "claimviewstepparts-edit";
    }

    navigate("/ClaimViewStepParts", {
      state: {
        action: action2,
        data: { itemData: v },
      },
    });
  };

  const onPrev = () => {
    navigate("/claims");
  };

  const onChangeClaimStDD = async (data) => {
    console.log("onChangeClaimStDD", {
      selectedItem,
      data,
    });

    // setClaimStatusDD(data?.list ? [...data?.list] : []);

    const stateidd = data?.item?.data?.stateid;
    setState(stateidd);
  };

  const onSelectItm = (data, action) => {
    if (navState?.action === "claim-edit" && action !== "onload") {
      return;
    }

    console.log("onSelectItm", data);

    // console.log("onSelectItm", data);
    setSelectedItem(data);
    if (data?.item?.data?.vrm) {
      setVrm(data?.item?.data?.vrm);
    }
    // setCarmodel(data?.item?.data?.carmodel || "");
    // setDatereg(data?.item?.data?.datereg);
    if (data?.item?.data?.email) {
      setClaimnotifyemail(data?.item?.data?.email);
    }
    setPolicyid(data?.item?.data?.policyid);

    // if (data?.item?.data?.state) {
    //   utils.getCliamStatusDD({
    //     setClaimStatusDD,
    //     defaultVal: data?.item?.data?.state,
    //   });
    // }
  };

  const getClaimData = async (data) => {
    setIsLoading(true);
    const res = await api.getClaim({ claimid: data?.claimid });
    setIsLoading(false);
    console.log("getClaimData res", res);

    if (res?.status === 200 && res?.data?.claimid) {
      setScData(res?.data);
    } else {
      toaster.create({
        title:
          res?.response?.data?.message ||
          res?.data?.message ||
          res?.message ||
          "error get claim data",
        type: "error",
      });
    }
  };

  const setScData = (data) => {
    console.log("setScData", data);
    setClaimRes(data);
    setVrm(data?.vrm);
    setDatereg(utils.dateToDateInput(data?.dateclaim));
    if (data?.vrm) {
      onSearch(data?.vrm);
    }
    setClaimnumber(data?.claimnumber);
    setMileageatclaim(data?.mileageatclaim);
    setLastservicedates(data?.lastservicedates);

    // if (data?.state) {
    utils.getCliamStatusDD({
      onChangeClaimStDD,
      // setClaimStatusDD,
      defaultVal: data?.state,
    });
    // }

    setFaultdiagnosed(data?.faultdiagnosed);
    setConfirmedwarrantyclaim(data?.confirmedwarrantyclaim);
    setAdvicedtodiagnosefault(data?.advicedtodiagnosefault);
    setAdvicedtosenddiagnostic(data?.advicedtosenddiagnostic);
    setHasbooklet(data?.hasbooklet === false ? true : false);
    setNotes(data?.notes);
    setClaimnotifyemail(data?.claimnotifyemail);
    setRepairinggarage(data?.repairinggarage);
    setFailurecause(data?.failurecause);
    setRepairsrequired(data?.repairsrequired);
  };

  useEffect(() => {
    const cb = async () => {
      console.log("useEffect cb", { itemData, navState });
      if (navState?.action === "claim-edit") {
        await getClaimData({ claimid: itemData?.claimid });
      } else {
        setScData(itemData);
        // utils.getCliamStatusDD({
        //   // setClaimStatusDD,
        //   onChangeClaimStDD,
        // });
      }
    };

    cb();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
      <Header
        label={`Claim${claimnumber ? " - " + claimnumber : ""}`}
        isLoading={isLoading}
      />
      <Layout type="w-75">
        <Flex flexFlow={"wrap"} columnGap="2rem" rowGap="2rem">
          {/* <Text fontWeight={"bold"} textStyle={fs}>
            Registration
          </Text> */}
          {/* <Flex>
            <Field.Root orientation="horizontal" gap={4}>
              <Field.Label textStyle={fs}>Policy</Field.Label>
            </Field.Root>
          </Flex>
          <SearchInput
            value={vrm}
            onChange={(v) => onSearch(v)}
            keyname={"claimview"}
          /> */}
          {/* <InputComp
            type="search"
            label={"Policy"}
            value={vrm}
            onChange={onSearch}
            keyname={"policy-search"}
            disabled={navState?.action === "claim-edit"}
          /> */}

          <CardRegistration
            label={"Policy"}
            type={"search"}
            value={vrm}
            onChange={onSearch}
            keyname={"policy-search"}
            disabled={navState?.action === "claim-edit"}
            searchic={false}
          />

          <InputComp
            type="date"
            label={"Date Entered"}
            value={datereg}
            onChange={setDatereg}
            disabled={navState?.action === "claim-edit"}
          />
          {/* <Flex>
            <Field.Root orientation="horizontal" gap={4}>
              <Field.Root orientation="horizontal" gap={4}>
                <Field.Label textStyle={fs}>Date Entered</Field.Label>
                <Input
                  type="date"
                  value={datereg}
                  onChange={(e) => setDatereg(e.target.value)}
                  textStyle={"md"}
                />
              </Field.Root>
            </Field.Root>
          </Flex> */}
          {/* <Button w={width1} bg="primary" textStyle={fs}>
              Lookup
            </Button> */}
        </Flex>

        <SimpleGrid columns={1} columnGap="1rem" rowGap="2rem" my="1rem">
          <Field.Root orientation="horizontal" gap={"1rem"}>
            <PolicyInfo data={selectedItem} />
          </Field.Root>
          {/* <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>Model</Field.Label>
            <Input
              type="text"
              value={carmodel}
              onChange={(e) => setCarmodel(e.target.value)}
              textStyle={"md"}
            />
          </Field.Root> */}
        </SimpleGrid>

        <SimpleGrid columns={1}>
          <TableList
            type={"simple"}
            headers={headers}
            items={list}
            selectedItem={selectedItem}
            onSelect={onSelectItm}
            h={"8rem"}
          />
        </SimpleGrid>

        <SimpleGrid
          columns={ismobile ? 1 : 2}
          columnGap="2rem"
          rowGap="1rem"
          mt="1rem"
        >
          <InputComp
            label={"Mileage at Claim"}
            type={"number"}
            value={mileageatclaim}
            onChange={setMileageatclaim}
          />

          <InputComp
            label={"Last Service Dates"}
            type={"date"}
            value={lastservicedates}
            onChange={setLastservicedates}
          />

          {/* <InputComp
            label={"Status of Claim"}
            type={"dropdown"}
            items={claimStatusDD}
            onChange={onChangeClaimStDD}
            placeholder={"Change State"}
            // disabled={!selectedItem}
            keyname={"claim-state"}
            required={true}
          /> */}

          {/* <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>Mileage at Claim</Field.Label>
            <Input
              type="number"
              value={mileageatclaim}
              onChange={(e) => setMileageatclaim(e.target.value)}
              textStyle={"md"}
            />
          </Field.Root> */}
          {/* <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>Last Service Dates</Field.Label>
            <Input
              type="date"
              value={lastservicedates}
              onChange={(e) => setLastservicedates(e.target.value)}
              textStyle={"md"}
            />
          </Field.Root> */}

          {/* <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>Status of Claim</Field.Label>
            <Input
              type="text"
              value={state}
              onChange={(e) => setState(e.target.value)}
              textStyle={"md"}
            />
          </Field.Root> */}
        </SimpleGrid>

        <Flex direction={"column"} gap={"2rem"}>
          <Flex
            flexFlow={"wrap"}
            // orientation={ismobile ? "vertical" : "horizontal"}
            gap={"1rem"}
            mt={"1rem"}
          >
            <ToggleSwitch
              label={"Fault Diagnosed from VAT Registered Garage"}
              value={faultdiagnosed}
              onChange={setFaultdiagnosed}
            />
            <ToggleSwitch
              label={"Conﬁrmed Warranty Claim"}
              value={confirmedwarrantyclaim}
              onChange={setConfirmedwarrantyclaim}
            />
            <ToggleSwitch
              label={"Adviced to Have Fault Diagnosed"}
              value={advicedtodiagnosefault}
              onChange={setAdvicedtodiagnosefault}
            />
            <ToggleSwitch
              label={"Adviced to Send Diagnostic"}
              value={advicedtosenddiagnostic}
              onChange={setAdvicedtosenddiagnostic}
            />
            <ToggleSwitch
              label={"Customer Has Policy Booklet"}
              value={hasbooklet}
              onChange={setHasbooklet}
            />
            {/* <Flex>
        <Field.Label textStyle={fs}></Field.Label>
        <ToggleSwitch label={"Luxury"} />
      </Flex> */}
            {/* <Field.Root orientation="horizontal" gap={4}> */}
            {/* </Field.Root> */}
          </Flex>
        </Flex>

        <SimpleGrid columns={1} columnGap="1rem" rowGap="1rem" mt="1rem">
          <Field.Root orientation="vertical">
            <Field.Label textStyle={fs}>ORCA Notes</Field.Label>
            <Textarea
              onChange={(e) => setNotes(e.target.value)}
              value={notes}
              textStyle={fs}
            />
          </Field.Root>
        </SimpleGrid>

        <SimpleGrid
          columns={ismobile ? 1 : 3}
          columnGap="2rem"
          rowGap="2rem"
          mt="1rem"
        >
          <InputComp
            label={"Customer Email ID"}
            value={claimnotifyemail}
            onChange={setClaimnotifyemail}
            required={true}
          />
          {/* <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>Customer Email ID</Field.Label>
            <Input
              type="email"
              value={claimnotifyemail}
              onChange={(e) => setClaimnotifyemail(e.target.value)}
              required={true}
              textStyle={"md"}
            />
          </Field.Root> */}
          <Flex>
            <ButtonComp
              label={"Send Email"}
              onClick={onSendEmail}
              keyname="sendemail"
              disabled={isLoading}
            />
          </Flex>
          {/* <Button
            onClick={() => onSendEmail()}
            w={width1}
            variant={"outline"}
            textStyle={"sm"}
          >
            Send Email
          </Button> */}
        </SimpleGrid>

        <SimpleGrid columns={1} columnGap="1rem" rowGap="1rem" mt="1rem">
          {/* <Field.Root orientation="vertical">
            <Field.Label textStyle={fs}>Repairing Garage</Field.Label>
            <Textarea
              textStyle={fs}
              value={repairinggarage}
              onChange={(e) => setRepairinggarage(e.target.value)}
            />
          </Field.Root> */}
          <Field.Root orientation="vertical">
            <Field.Label textStyle={fs}>
              Cause of Failure & Repairs Required
            </Field.Label>
            <Textarea
              textStyle={fs}
              value={failurecause}
              onChange={(e) => setFailurecause(e.target.value)}
            />
          </Field.Root>
          <Field.Root orientation="vertical">
            <Field.Label textStyle={fs}>AU Internal Comments</Field.Label>
            <Textarea
              value={repairsrequired}
              onChange={(e) => setRepairsrequired(e.target.value)}
              textStyle={fs}
              rows={5}
            />
          </Field.Root>
        </SimpleGrid>
      </Layout>

      <Flex
        // direction={ismobile ? "column" : "row"}
        justifyContent="space-between"
        alignItems="center"
        mt={"1rem"}
        wrap={"wrap"}
        gap={"1rem"}
      >
        {/* <Text
            onClick={() => onClear()}
            fontWeight={"bold"}
            textStyle={"lg"}
            alignSelf={"flex-end"}
          >
            Clear
          </Text> */}
        <ButtonComp label={"Clear"} onClick={onClear} keyname={"clear"} />

        <Flex gap={"1rem"} alignItems={"center"}>
          <ButtonComp label={"Close"} onClick={onPrev} keyname={"close"} />
          <ButtonComp
            label={"Next"}
            onClick={onNext}
            keyname={"next"}
            disabled={isLoading}
          />

          {/* <Button
              onClick={() => onPrev()}
              variant={"outline"}
              textStyle={"sm"}
            >
              Close
            </Button> */}
          {/* <Button onClick={() => onNext()} bg="primary" textStyle={"sm"}>
              Next
            </Button> */}
        </Flex>
      </Flex>
    </Flex>
  );

  // return (
  //   <>
  //     <Flex
  //       display={status === "parts" ? "flex" : "none"}
  //       flex={1}
  //       overflow={"hidden"}
  //       direction={"column"}
  //       p={"2rem"}
  //     >
  //       <StepParts
  //         disabled
  //         setStatus={setStatus}
  //         setPayl={setPayl}
  //         payl={payl}
  //       />
  //     </Flex>
  //     <Flex
  //       display={status === "parts" ? "none" : "flex"}
  //       flex={1}
  //       overflow={"hidden"}
  //       direction={"column"}
  //       p={"2rem"}
  //     >
  //       <Content setStatus={setStatus} setPayl={setPayl} payl={payl} />
  //     </Flex>
  //   </>
  // );

  // return (
  //   <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
  //     {status === "parts" ? (
  //       <StepParts setStatus={setStatus} setPayl={setPayl} payl={payl} />
  //     ) : (
  //       <Content setStatus={setStatus} setPayl={setPayl} payl={payl} />
  //     )}
  //   </Flex>
  // );
}

export default ClaimView;
